import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AngularDiProviders } from '../../injector/components/angular-di/AngularDiProviders';
import { HdResolvedComponent } from '../../routing/components/resolved-component/HdResolvedComponent';
import { useEmailVerificationGuard } from '../../auth/hooks/useEmailVerificationGuard';
import { useTrialExpiryGuard } from '../team/hooks/useTrialExpiryGuard';
import { useUserPersonaGuard } from '../../auth/hooks/useUserPersonaGuard';
import { CreateActivateAngularticsService } from '../../core/services/create-activate-angulartics.service';
import { SessionTrackingAngularticsService } from '../../core/services/session-tracking-angulartics.service';
import { ActivateListPage } from './ActivateListPage/ActivateListPage';
import { CreateActivation } from './CreateActivation';
import { ShowActivation } from './ShowActivation';
import { useActivationGuard } from './useActivationGuard';

import '../../../../angular/dist/runtime.js';
import '../../../../angular/dist/polyfills.js';
import '../../../../angular/dist/main.js';

export default function Activation() {
  const { executeActivationGuard } = useActivationGuard();

  const { executeEmailVerificationGuard } = useEmailVerificationGuard();
  const { executeTrialExpiryGuard } = useTrialExpiryGuard();
  const { executeUserPersonaGuard } = useUserPersonaGuard();

  return (
    <HdResolvedComponent
      Component={ActivationInner}
      canActivate={[ executeActivationGuard, executeEmailVerificationGuard, executeTrialExpiryGuard, executeUserPersonaGuard ]}
    />
  );
}

const providers = [
  { provide: SessionTrackingAngularticsService, useExisting: CreateActivateAngularticsService }
];

export function ActivationInner() {
  return (
    <AngularDiProviders providers={providers}>
      <Routes>
        <Route key='create-activation' path='create' element={<CreateActivation />} />

        <Route key='show-activation' path=':seqId/*' element={<ShowActivation />} />

        <Route key='activation-list' path='' element={<ActivateListPage />} />
      </Routes>
    </AngularDiProviders>
  );
}
